import "./App.css";
import { Home } from "./pages";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
function App() {
  return (
    <>
      <Home />
    </>
  );
}

export default App;
